import {Component} from "react";
import React from "react";

function Markmessagesasread(message_id) {
  let res;
  let xhr = new XMLHttpRequest();
  xhr.open("PUT", "https://api.mercadolibre.com/messages/mark_as_read/id?access_token=%24ACCESS_TOKEN");
  xhr.addEventListener( 'load',  function () {
    res = JSON.parse(this.responseText);
 });
  xhr.send();
  return res;
}


function GetAttachment(attachment_id) {
  let res;
  let access_token = sessionStorage.getItem("access_token");
  let url = "https://api.mercadolibre.com/messages/attachments/" + attachment_id + "?access_token=" + access_token;
  let xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.addEventListener( 'load',  function () {
     res = JSON.parse(this.responseText);
  });
  xhr.send();
  return res;
}

class Messages extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      user:null
    };
  }
  componentDidMount() {
    let access_token = sessionStorage.getItem("access_token");
    let order_id = sessionStorage.getItem("order_id");
    let url = "https://api.mercadolibre.com/messages/orders/" + order_id + "?access_token=" + access_token;
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result.results);
          this.setState({
            isLoaded: true,
            items: result.results
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const { items } = this.state;
    items.reverse();
    return (
      <ul className="list-group">
      {items.map(item => (
            <li className="list-group-item list-group-item-info" key={item.text.plain}>
              <span className="badge">{item.from.name}</span>
              {item.text.plain}
            </li>
          ))}
      </ul>
    );
  }
}

export default Messages;